<template>
  <div>
    <h1 class="common__main-title">Deadline Setting List</h1>
    <Search
      class="search"
      @search="search"
    />
    <div class="">
      <b-button
        pill
        variant="primary"
        @click="moveToModification"
      >
        Update
      </b-button>
    </div>
    <div class="pager-box">
      <PagerComponent v-model="pager" @changePage="changePage" class="mb-2" />
    </div>
    <DeadlineList :deadlines="deadlines" :pager="pager" ref="deadlineList" />
    <div class="pager-box">
      <PagerComponent v-model="pager" @changePage="changePage" class="mb-2" />
    </div>
    <div class="">
      <b-button
        pill
        variant="primary"
        @click="moveToModification"
      >
        Update
      </b-button>
    </div>
    <Loading :isLoading="isLoading" />
  </div>
</template>

<script>
import _ from 'lodash';
import PagerComponent from '@/components/parts/Pager.vue';
import DeadlineList from '@/components/parts/deadline/DeadlineList.vue';
import Search from '@/components/parts/deadline/DeadlineSearch.vue';
import { mapState } from 'vuex';
import Loading from '@/components/parts/modal/Loading.vue'

export default {

  data() {
    return {
      isLoading: false,
      conditions: null,
      allPageDeadlines: [],
    };
  },

  computed: {
    ...mapState({
      pager: (state) => state.deadlines.pager,
      deadlines: (state) => state.deadlines.deadlines,
    }),
  },

  components: {
    Search,
    PagerComponent,
    Loading,
    DeadlineList,
  },

  methods: {
    changePage(page) {
      this.search(this.conditions, page);
    },
    async search(conditions, page = 1) {
      this.isLoading = true;
      this.conditions = conditions;
      try {
        await this.$store.dispatch('fetchDeadlines', { conditions, page });
        this.allPageDeadlines = _.uniqBy([
          ...this.deadlines,
          ...this.allPageDeadlines,
        ], 'id')
      } catch {
        // empty
      }
      this.isLoading = false;
    },
    moveToModification() {
      const selectedDeadlineIdGroups = _.chain(this.allPageDeadlines)
        .filter((deadline) => {
          return this.$refs.deadlineList.selectedItem.includes(deadline.id)
        })
        .groupBy('expired')
        .map((groups) => _.map(groups, (group) => group.id))
        .values()
        .value();

      this.$router.push({
        name: 'DeadlineModification',
        params: { deadlineIdGroups: selectedDeadlineIdGroups },
      });
    },
  },
};
</script>
